<template>
  <div class="app-content ap monitors">
    <b-row class="row mb-4">
      <b-col>
        <div class="d-flex h-100 w-100 align-items-center">
          <h1 class="ap__main-title">Evolving Monitors</h1>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { monitorsDataMixin } from '../mixins/monitorsDataMixin.js';

import {
  GLOBAL_CHANGE_SECTION
} from "@/store/actions.type";

import {
  STATE_MONITORS_CURRENT_CATEGORY_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorsDashboard',
  mixins: [monitorsDataMixin],
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    if(this.section != 'monitors') {
      this.$store.dispatch(GLOBAL_CHANGE_SECTION, 'monitors');
      this.getMonitorsData();
    }

    this.$store.commit(STATE_MONITORS_CURRENT_CATEGORY_SET, '');
  }
}
</script>

<style lang="scss">
.app {

  &__loading {
    left: 0;
    top: 0;
    z-index: 999;
  }
}

*:focus {
  outline: none;
}

.b-toast-primary .toast {
    background-color: #fff !important;
    border-color: $color-java !important;
    color: $color-abbey !important;
    font-weight: 600;

  .toast-header {
    color: #fff !important;
    background-color: $color-java !important;
    border-bottom-color: $color-java !important;

    button {

      &:focus {
        outline: none;
      }
    }
  }
}
</style>